import createEnum from 'scripts/lib/create_enum';

import createModel, { prop } from './lib/create_model';
import TeamAssistCitation from './team_assist_citation';
import TeamAssistRating from './team_assist_rating';

const MessageRole = createEnum('agent_question', 'ai_response');
const MessageType = createEnum('info', 'question', 'suggested_response');

const TeamAssistMessage = createModel({
  modelName: 'TeamAssistMessage',

  properties: {
    agentId: prop(String),
    citations: prop([TeamAssistCitation]).default([]),
    confidence: prop(Number),
    content: prop(String),
    displayedMessage: prop(String),
    error: prop(Boolean).default(false),
    createdAt: prop(String),
    customerId: prop(String),
    id: prop(String),
    isRetrying: prop(Boolean).default(false),
    rating: prop(TeamAssistRating).default(null),
    reviewReasons: prop([String]).default([]),
    role: prop(String).oneOf(...Object.values(MessageRole)),
    sessionId: prop(String),
    type: prop(String).oneOf(...Object.values(MessageType)),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },

    RatingReason: TeamAssistRating.Reason,
    RatingValue: TeamAssistRating.Value,
    Role: MessageRole,
    Type: MessageType,
  },
});

export default TeamAssistMessage;
